import { render, staticRenderFns } from "./RoutesInformationsRoute.vue?vue&type=template&id=273e3611&scoped=true&"
import script from "./RoutesInformationsRoute.vue?vue&type=script&lang=js&"
export * from "./RoutesInformationsRoute.vue?vue&type=script&lang=js&"
import style0 from "./RoutesInformationsRoute.vue?vue&type=style&index=0&lang=css&"
import style1 from "./RoutesInformationsRoute.vue?vue&type=style&index=1&id=273e3611&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273e3611",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VDialog})
